module.exports = __webpack_public_path__ + "img/survey.5da7c3a2.svg";